<template>
  <div class="w-full" :class="{ 'h-[100vh]': wopiStore.iFrameLoaded }">
    <iframe
      v-if="wopiStore.currentDocId"
      class="w-full h-[100vh]"
      id="wopi-online-viewer"
      name="wopi-online-viewer"
      ref="wopiIframe"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
import { useWopiStore } from "../stores/wopi.store";
import { AlertDuration, AlertType, useAlertManager } from "@pasta/box-v2";
import { get } from "lodash";

const wopiStore = useWopiStore();
const wopiIframe = ref<HTMLIFrameElement | null>(null);

onMounted(() => {
  window.addEventListener("message", eventListener);
});
onUnmounted(() => {
  window.removeEventListener("message", eventListener);
});

let timer: number | undefined = undefined;

async function eventListener(event: MessageEvent) {
  if (event.origin !== wopiStore.trustedUrl) return;
  const data = JSON.parse(event.data);
  if (!get(data, "MessageId")) return;

  if (data.MessageId === "App_LoadingStatus" && get(data, "Values.Status") === "Initialized") {
    timer = setTimeout(() => {
      wopiStore.close();
      useAlertManager().createAlert({
        type: AlertType.ERROR,
        duration: AlertDuration.INFINITE,
        message:
          "Le document que vous essayez d'éditer ne semble pas valide, veuillez l'ouvrir dans Office pour le réparer",
      });
    }, wopiStore.frameLoadTimeout || 10_000) as unknown as number;
  }

  if (data.MessageId === "App_LoadingStatus" && get(data, "Values.Status") === "Document_Loaded") {
    wopiStore.setIFrameLoaded(true);
    clearTimeout(timer);
    timer = undefined;
  }

  if (data.MessageId === "UI_Close") {
    wopiStore.close();
    if (timer) {
      clearTimeout(timer);
      timer = undefined;
    }
  }
}
</script>
